import isEmpty from 'lodash/isEmpty';
import last from 'lodash/last';

const LIMIT_WIDGETS_IN_ONE_ROW = 3;
const PADDING_ROW = 20;

export const calcTemporaryState = ({
  stateWidgets,
  widgetPositions,
  rowPositions,
  boardWidth = 0,
  dragInfo,
}) => {
  let rowIndex = null;
  let cellIndex = null;
  let inRow = null;

  const { position } =
    widgetPositions.find(({ id }) => id === dragInfo?.id) || {};
  const y = position?.top + dragInfo?.y + 30;
  const x = position?.left + dragInfo?.x + 10;

  if (y <= 0) {
    rowIndex = 0;
  } else if (y >= last(rowPositions)?.to) {
    rowIndex = rowPositions.length - 1;
  } else {
    for (let i = 0; i < rowPositions.length; i++) {
      const { from, to } = rowPositions[i];
      const { from: nextFrom } = rowPositions[i + 1] || {};
      const nextIndex = Math.min(i + 1, rowPositions.length - 1);

      if (y > from && y <= to) {
        if (from + PADDING_ROW > y) {
          rowIndex = i;
        } else if (to - PADDING_ROW < y) {
          rowIndex = nextIndex;
        } else {
          rowIndex = i;
          inRow = true;
        }
        break;
      } else if (y > to && y <= nextFrom) {
        rowIndex = nextIndex;
        break;
      }
    }
  }

  if (inRow && stateWidgets[rowIndex]) {
    const cellCount = stateWidgets[rowIndex].length;
    const widthCell = boardWidth / cellCount;
    const index = Math.max(Math.floor(Math.min(x, boardWidth) / widthCell), 0);
    const before = Math.min(x, boardWidth) % widthCell < widthCell / 2;
    cellIndex = before ? index : index + 1;
  }

  let temporaryState = stateWidgets
    .map((row) => row.filter(({ id }) => id !== dragInfo?.id))
    .filter((i) => !isEmpty(i));

  const dragWidget = stateWidgets.reduce(
    (acc, row) => row.find(({ id }) => id === dragInfo?.id) || acc,
    null
  );

  return inRow &&
    temporaryState[rowIndex]?.length + 1 <= LIMIT_WIDGETS_IN_ONE_ROW
    ? [
        ...temporaryState.slice(0, rowIndex),
        [
          ...(temporaryState[rowIndex]
            ? temporaryState[rowIndex].slice(0, cellIndex)
            : []),
          dragWidget,
          ...(temporaryState[rowIndex]
            ? temporaryState[rowIndex].slice(cellIndex)
            : []),
        ],
        ...temporaryState.slice(rowIndex + 1),
      ]
    : [
        ...temporaryState.slice(0, rowIndex),
        [dragWidget],
        ...temporaryState.slice(rowIndex),
      ];
};
